import { setAutoFreeze } from 'immer';

const env = import.meta.env.MODE;
const isProd = env === 'production';

if (isProd) {
  setAutoFreeze(false);
}
